module.exports = __webpack_public_path__ + "static/media/logo-transparent.84d713cc.png";